export default __webpack_public_path__ + "static/gallery-award-nspp-d8f49c6443f2e3978d02fc0294884ec2.jpg";